import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VRow,[_c(VCol,{class:_vm.lastColumnLeft,attrs:{"cols":"12","md":"8"}},[_c(VContainer,{class:_vm.lastInput},[_vm._t("input")],2)],1),_c(VCol,{class:_vm.lastColumnRight,attrs:{"cols":"12","md":"4"}},[_c(VContainer,{class:_vm.lastValidation},[_vm._t("validation")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }